import { ContactUs } from "../_components/_contact-us";

window.$ = jQuery;

$( document ).ready( function () {

	ContactUs();

} );